import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import { toast } from "react-toastify";

function AddSubCategoryForm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const { id } = useParams();
  const [mainCategories, setMainCategories] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    category_id: "",
    sub_category_name: "",
    sub_category_name_arabic: "",
    category_name: "",
    description: "",
    user_id: user?.user.id,
    outlet_id: user?.user.outlet_id,
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const postData = (csrfToken) => {
      if (!id) {
        axios
          .post(`${apiKey}/api/rms/admin/subCategories`, formData, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          })
          .then((res) => {
            toast.success("Success", {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            navigate(-1);
          })
          .catch((err) => {
            Object.keys(err.response.data.data).forEach((item) => {
              err.response.data.data[item].forEach((i) => {
                toast.error(i || "Validation Error");
              });
            });
          })
          .finally(() => setLoading(false));
      } else {
        axios
          .put(`${apiKey}/api/rms/admin/subCategories/${id}`, formData, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          })
          .then((res) => {
            toast.success("Success", {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            navigate(-1);
          })
          .catch((err) => {
            Object.keys(err.response.data.data).forEach((item) => {
              err.response.data.data[item].forEach((i) => {
                toast.error(i || "Validation Error");
              });
            });
          })
          .finally(() => setLoading(false));
      }
    };
    handleCSRF(postData);
  };

  useEffect(() => {
    if (id) {
      setPageLoading(true);
      const fetchSubCat = (csrfToken) => {
        axios
          .get(`${apiKey}/api/rms/admin/subCategories/${id}`, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
            params: {
              is_sub_cat: 1,
            },
          })
          .then((res) => {
            setFormData(res.data[0]);
          })
          .catch((err) => {
            // setError(err.response.data.message);
            console.log(err);
          })
          .finally(() => setPageLoading(false));
      };
      handleCSRF(fetchSubCat);
    }
    const fetchMainCats = (csrfToken) => {
      axios
        .get(`${apiKey}/api/rms/admin/categories`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
          params: {
            is_sub_cat: 1,
            outletId: user?.user.outlet_id,
          },
        })
        .then((res) => {
          const mappedOptions = res.data.map((item) => ({
            value: item.id,
            label: item.category_name,
          }));
          setMainCategories(mappedOptions);
        })
        .catch((err) => {
          // setError(err.response.data.message);
          console.log(err);
        })
        .finally(() => setPageLoading(false));
    };
    handleCSRF(fetchMainCats);
  }, [id, user?.token, user?.user.outlet_id]);

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="loading..." />
      </div>
    );
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl">Add Sub Category</h1>
          </div>
        </div>
        <div className="w-full">
          <form className="w-full" onSubmit={handleSubmit}>
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full">
              <label className="w-full lg:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Category Name
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder="Select Category Name"
                    options={mainCategories}
                    defaultValue={{
                      label: formData.category_name,
                      value: formData.category_id,
                    }}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        category_id: e.value,
                      })
                    }
                  />
                </div>
              </label>
              <label className="w-full lg:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative ">
                  Sub Category Name English
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Sub Category Name English"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    onChange={handleChange}
                    value={formData.sub_category_name}
                    name="sub_category_name"
                  />
                </div>
              </label>
              <label className="w-full lg:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative">
                  Description
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Description"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    onChange={handleChange}
                    value={formData.description}
                    name="description"
                  />
                </div>
              </label>
            </div>

            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full mt-2 ">
              <label className="w-full lg:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Sub Category Name Arabic
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Sub Category Name Arabic"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    onChange={handleChange}
                    value={formData.sub_category_name_arabic}
                    name="sub_category_name_arabic"
                  />
                </div>
              </label>
            </div>

            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                Submit
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AddSubCategoryForm;
